import { FC } from 'react';
import { useLoginAdapter } from './login-adapter';

// -----------------------------------------------------------------------------
const Gate: FC<any> = () => {
  const { assetBaseUrl } = useLoginAdapter();
  // ---------------------------------------------------------------------------
  return (
    <div className="login-image">
      <img
        className="lightning"
        src={`${assetBaseUrl}/static_next/login/login-gate-bg.webp`}
        alt="sign up"
      />
    </div>
  );
};

export default Gate;
